module.exports = __webpack_public_path__ + "img/L-Form.0f30b621.png";